// dependencies
import { useState } from "react"
import { useNavigate } from "react-router";

// context
import { useAuth } from "../../contexts/AuthContext"

// hooks 
import { useFetchProjects } from "../../hooks/useFirebase"

// components
import { ProjectCard } from "../../components/pages/projects/ProjectCard"
import PrimaryBtn from "../../components/btns/PrimaryBtn";
import BB8LoadingPage from "../../components/layout/BB8LoadingPage";

// styles
import styles from "./css/Projects.module.css"


const tagColors = {
    "Personal Project": { bg: "#232338", text: "#fff" },
    "Freelance Project": { bg: "#97119c", text: "#fff" },
    "Uni Project": { bg: "#af3d73", text: "#fff" },
    "Active": { bg: "#60b1cc", text: "#fff" },
    "Completed": { bg: "#4f3d73", text: "#fff" },
};


const Projects = () => {
    const [selectedTag, setSelectedTag] = useState(null)
    const { currentUser } = useAuth()
    let navigate = useNavigate();

    // fetch projects
    const { projects, loading } = useFetchProjects()
    const filteredProjects = selectedTag ? projects.filter(project => project.tags?.includes(selectedTag)) : projects

    // get tags from projects
    // const allTags = Array.from(new Set(projects.flatMap(p => p.tags || [])))
    // simple all tags hard coded
    const allTags = ["Freelance Project", "Personal Project", "Uni Project", "Active", "Completed"]

    const handleNavigatePage = (page) => {
        navigate(page)
    }

    

    if (loading) {
        return (
            <>
                <BB8LoadingPage />
            </>
        )
    }

    return (
        <div className={styles.projectsPageContainer}>
            <div className={styles.contentContainer}>
                <div className={styles.titleContainer}>
                    <h1 className={styles.title}>My Projects</h1>
                    <p className={styles.text}>
                        A collection of my work across mobile and web development. Each project represents a unique challenge and solution. 
                        <br />You can click on project cards to open them in more detail.
                    </p>
                    {currentUser && (
                        <PrimaryBtn text={"Add Project"} onClick={() => handleNavigatePage("/projects/add")} />
                    )}
                </div>

                <div className={styles.tagsFilterContainer}>
                    <button 
                        onClick={() => setSelectedTag(null)}
                        className={!selectedTag ? styles.activeTagBtn : styles.tagBtn}
                        style={{ backgroundColor: "#000", color: "#fff" }}
                    >
                        All
                    </button>

                    {allTags.map((tag, index) => {
                        const { bg, text } = tagColors[tag] || { bg: "#ddd", text: "#000" };
                        const isActive = tag === selectedTag;
                        return (
                            <button
                                key={index}
                                onClick={() => setSelectedTag(tag)}
                                className={isActive ? styles.activeTagBtn : styles.tagBtn}
                                style={{ backgroundColor: bg, color: text }}
                            >
                                {tag}
                            </button>
                        )
                    })}
                </div>

                <div className={styles.projectCardsContainer}>
                    {filteredProjects.length === 0 ? (
                        <p className="no-projects">No Projects Found</p>
                    ) : (
                        filteredProjects.map(({ id, title, description, thumbnail, tags }) => (
                            <ProjectCard
                                key={id}
                                id={id}
                                title={title}
                                description={description}
                                thumbnail={thumbnail}
                                tags={tags}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}

export default Projects
